import 'slick-carousel'
import $ from 'jquery'

$(document).ready(function () {
  $('.awards-slider__carousel').each(function (i, el) {
    const autoplay = Boolean($(el).data('autoplay'))

    if (!$(el).hasClass('slick-initialized')) {
      $(el).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: autoplay,
        autoplaySpeed: 3000,
        appendArrows: $('.awards-slider__item'),
      })

      $(el).on('mouseenter touchstart', function () {
        $(el).slick('slickPause')
      })

      $(el).on('mouseleave touchend', function () {
        $(el).slick('slickPlay')
      })
    }
  })
})

$(function () {
  $('.awards-slider__carousel .slick-prev').on('click', function () {
    $('.awards-slider__carousel').slick('slickPrev')
  })
  $('.awards-slider__carousel .slick-next').on('click', function () {
    $('.awards-slider__carousel').slick('slickNext')
  })
})
